import React, { Component, PropTypes } from 'react';
import DatePicker from 'react-datepicker';
import { lang } from '../../strings';
import { format } from '../../utils/string';
import { getDate, formatDate } from '../../utils/date';
import { trackEvent, SIM, LOAD } from '../../utils/analytics';

export default class SimCardExtraDialog extends Component {

   constructor(props) {
      super(props);
      this.state = this.makeInitialState(props);
   }

   makeInitialState(props) {
      return {
         selectedDate: getDate(),
         activationType: null
      };
   }

   componentDidMount() {
      trackEvent(SIM, LOAD);
   }

   render() {
      let {onClose, price} = this.props;
      let {selectedDate, activationType} = this.state;
      let showDatePicker = activationType == SimCardExtraDialog.activationTypes.date;

      return (
         <div className="mp-popup-container">
            <div className="mp-popup-content">
               <a href="#" className="mp-close" onClick={onClose}>&times;</a>
               <h2 className="h5 color-dark-blue">{lang.simCard.extraDialog.title}</h2>
               <p>{lang.simCard.extraDialog.intro}</p>

               <form onSubmit={this.onSubmit}>
                  <h2 className="h5 color-dark-blue">{lang.simCard.extraDialog.activation}</h2>
                  <ul className="mp-list">
                     <li>
                        <label>
                           <input type="radio" name="activationType" onChange={this.onActivationTypeChange} value={SimCardExtraDialog.activationTypes.direct} /> {lang.simCard.extraDialog.direct}
                        </label>
                        <span style={{marginLeft: 10}} className="mp-small">{lang.simCard.extraDialog.tooltip.direct}</span>
                     </li>
                     <li>
                        <label>
                           <input type="radio" name="activationType" onChange={this.onActivationTypeChange} value={SimCardExtraDialog.activationTypes.date} /> {lang.simCard.extraDialog.date}
                        </label>
                        <span style={{marginLeft: 10}} className="mp-small">{lang.simCard.extraDialog.tooltip.date}</span>
                     </li>
                  </ul>
                  {showDatePicker ? <DatePicker minDate={getDate()} locale="sv" selected={selectedDate} onChange={this.onDateChange} /> : null}
                  <p className="mp-info">
                     {format(lang.simCard.extraDialog.important, price)}
                  </p>
                  <input type="submit" className={this.setClass()} value={lang.simCard.extraDialog.button} />
               </form>
            </div>
         </div>
      );
   }

   setClass() {
      let { activationType } = this.state;
      return activationType ? 'mp-submit' : 'mp-disabled mp-submit';
   }

   onSubmit = ev => {
      ev.preventDefault();
      let activationTime = null;
      if(this.state.activationType == SimCardExtraDialog.activationTypes.direct) {
         activationTime = getDate();
      }
      else if(this.state.activationType == SimCardExtraDialog.activationTypes.date) {
         activationTime = formatDate(this.state.selectedDate, 'L');
      }
      this.props.onSubmit(activationTime);
   };

   onDateChange = date =>  {
      this.setState({selectedDate: date});
   };

   onActivationTypeChange = ev =>  {
      this.setState({activationType: ev.target.value});
   };
}

SimCardExtraDialog.activationTypes = {
   direct: 0,
   date: 2
};

SimCardExtraDialog.propTypes = {
   onClose: PropTypes.func.isRequired,
   onSubmit: PropTypes.func.isRequired,
   price: PropTypes.string.isRequired
};